import {
  Box,
  Divider,
  Grid,
  Paper,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  useMediaQuery,
  useTheme,
  Autocomplete,
  TextField,
  InputAdornment,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  Checkbox,
  Tooltip,
} from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";
import { useEffect, useState } from "react";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { fExecuteAPI } from "../../Server/Apis";
import GCAutocompleteCheckboxFixSizeUid from "../VendorDiscontinueChangeRequest/GCAutocompleteCheckboxFixSizeUid";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { IconButton } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

const FinancePayableReport = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const branchData = useSelector((state) => state.SliceDB.value.DbData.Branch);
  const kernOBj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const [reportUrl, setReportUrl] = useState("");
  const screenType = "Payable";
  const [showFilters, setShowFilters] = useState(true);

  const [filterObj, setFilterObj] = useState({
    branch: "",
    party: "All",
    fromDate: dayjs().startOf("year"),
    toDate: dayjs(),
    parentAccount: "ALL",
    reportOption: "",
    trialBalanceVal: "ALL",
    osDueSummaryPendingInvoiceVal: "ALL",
    agingSummaryVal: "ALL",
    agingDetailsOption: "",
    agingDetailsDueDate: false,
    agingDetailsExcelFormat: false,
    oDueSummaryDetail: false,
    accountOptions: [],
    accountName: "",
    group: "ALL",
    segment: "ALL",
    salesman: "ALL",
    class: "ALL",
  });

  const [dropdownData, setDropdownData] = useState({
    group: [],
    segment: [],
    salesman: [],
    class: [],
    parentAC: [],
  });

  useEffect(() => {
    const fetchDropdownData = async () => {
      const result = await fExecuteAPI("getPayableReceivableDropdownData", {
        vType: "Payable",
        vSONAS_INVOICE: "Y",
      });
      if (result) {
        const { cmbClass, cmbGrp, cmbSalesman, cmbSegment, parentAC } = result;
        setDropdownData({
          group: cmbGrp || [],
          segment: cmbSegment || [],
          salesman: cmbSalesman || [],
          class: cmbClass || [],
          parentAC: parentAC || [],
        });
      }
    };
    fetchDropdownData();
  }, []);

  const handleFilterChange = (key, value) => {
    setFilterObj((prev) => {
      const updated = { ...prev, [key]: value };
      if (key === "reportOption" && value !== "oDueSummary")
        updated.oDueSummaryDetail = false;
      if (key === "reportOption" && value !== "agingDetails") {
        updated.agingDetailsDueDate = false;
        updated.agingDetailsExcelFormat = false;
      }
      return updated;
    });
  };

  const handleReset = () => {
    setFilterObj({
      branch: "",
      party: "All",
      fromDate: dayjs().startOf("year"),
      toDate: dayjs(),
      parentAccount: "ALL",
      reportOption: "",
      trialBalanceVal: "ALL",
      osDueSummaryPendingInvoiceVal: "ALL",
      oDueSummaryDetail: false,
      agingSummaryVal: "ALL",
      agingDetailsOption: "",
      agingDetailsDueDate: false,
      agingDetailsExcelFormat: false,
      accountOptions: [],
      accountName: "",
      group: "ALL",
      segment: "ALL",
      salesman: "ALL",
      class: "ALL",
    });
    setReportUrl("");
  };

  const getPrntyp = () => {
    const {
      reportOption,
      oDueSummaryDetail,
      osDueSummaryPendingInvoiceVal,
      agingSummaryVal,
      agingDetailsDueDate,
      agingDetailsExcelFormat,
      trialBalanceVal,
    } = filterObj;

    switch (reportOption) {
      case "oDueSummary":
        return oDueSummaryDetail ? "OSD" : "OS";
      case "oDueDetail":
        return "OSDETL";
      case "osDueSummaryPendingInvoice":
        return (
          {
            General: "OSNPDC",
            Excel: "OSNPDCX",
            Summary: "OSNPDCS",
          }[osDueSummaryPendingInvoiceVal] || ""
        );
      case "agingDetails":
        if (agingDetailsExcelFormat && agingDetailsDueDate) return "AGDXOD";
        if (!agingDetailsExcelFormat && agingDetailsDueDate) return "AGDOD";
        if (agingDetailsExcelFormat && !agingDetailsDueDate) return "AGDX";
        return "AGD";
      case "agingSummary":
        return (
          {
            "With Drill Down": "AG",
            "Without Drill Down": "AGND",
            "Over Due Ageing": "AGOD",
            "Over Due Forecast": "AGFC",
            "Over Due Forecast Branchwise": "AGFCB",
            "Daywise  Ageing": "AGDW",
          }[agingSummaryVal] || ""
        );
      case "agingDetailPendingInvoice":
        return "AGNPDC";
      case "trialBalance":
        return (
          {
            Consolidated: "TBLCNS",
            Full: "TBL",
            Partial: "TBLP",
          }[trialBalanceVal] || ""
        );
      default:
        return "";
    }
  };

  const handleViewReport = () => {
    const acCD = filterObj.accountOptions.find(
      (account) => account.Name1 === filterObj.accountName
    );
    const parentCD = dropdownData.parentAC.find(
      (item) => item.Name1 === filterObj.parentAccount
    );
    const prntyp = getPrntyp();
    const URL = kernOBj?.WEB_REPORT_BASE_URL?.Val;

    const finalUrl =
      `${URL}/WMS/SubKontenOSReport?` +
      `PrntAcCode=${parentCD?.AcCd?.trim() || "ALL"}` +
      `&Br=${filterObj.branch || ""}` +
      `&AcCd=${acCD?.AcCd?.trim() || "ALL"}` +
      `&Date1=${
        filterObj.fromDate ? filterObj.fromDate.format("MM/DD/YYYY") : ""
      }` +
      `&Date2=${filterObj.toDate ? filterObj.toDate.format("MM/DD/YYYY") : ""}` +
      `&Typ=${screenType === "Receivable" ? "D" : "C"}` +
      `&Grp1=${filterObj.group?.trim() || "ALL"}` +
      `&Grp2=${filterObj.segment?.trim() || "ALL"}` +
      `&Grp3=${filterObj.salesman?.trim() || "ALL"}` +
      `&SplAc1=${filterObj.class?.trim() || "ALL"}` +
      `&prntyp=${prntyp || ""}` +
      `&ReportTile=`;

    setReportUrl(finalUrl);
    setShowFilters(false);
  };

  const getAccountData = async (searchText) => {
    try {
      const result = await fExecuteAPI("AccountTransSearch_GETROW", {
        Loc: "",
        Data: "%" + (searchText || "All"),
        Type: "Any",
        AcTyp: "C",
        Exact: "N",
      });
      if (result?.Type === "SUCCESS") {
        handleFilterChange("accountOptions", result.ResultSet);
      }
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  return (
    <Box sx={{ width: "100%", p: 1 }}>
      <Tooltip title={showFilters ? "Hide Filters" : "Show Filters"}>
        <IconButton
          onClick={() => setShowFilters((prev) => !prev)}
          color="primary"
        >
          {showFilters ? <CloseIcon /> : <FilterAltIcon />}
        </IconButton>
      </Tooltip>

      <Grid container spacing={1}>
        {showFilters && (
          <Grid item xs={12} md={3}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                height: "100%",
                height: isMdUp ? "calc(100vh - 128px)" : "auto",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Filters
              </Typography>

              {/* Dates */}
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography>From</Typography>
                  <CmpDatePickerField001V1
                    xLabelText=""
                    xName="fromDate"
                    xValue={filterObj.fromDate}
                    xOnChange={(val) => handleFilterChange("fromDate", val)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography>To</Typography>
                  <CmpDatePickerField001V1
                    xLabelText=""
                    xName="toDate"
                    xValue={filterObj.toDate}
                    xOnChange={(val) => handleFilterChange("toDate", val)}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />
              <Typography>Branch</Typography>
              <GCAutocompleteCheckboxFixSizeUid
                xLabelText="Branch"
                xValue={filterObj.branch}
                setValue={(val) => handleFilterChange("branch", val)}
                options={branchData}
                objName="branch"
                placeholder="Search Branch"
              />

              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2">A/c Name</Typography>
              <Autocomplete
                fullWidth
                value={filterObj.accountName}
                onChange={(e, val) => handleFilterChange("accountName", val)}
                inputValue={filterObj.accountName ?? ""}
                onInputChange={(e, val) =>
                  handleFilterChange("accountName", val)
                }
                options={filterObj.accountOptions.map((a) => a.Name1)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        getAccountData(filterObj.accountName);
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {params.InputProps.endAdornment}
                          <InputAdornment
                            position="end"
                            sx={{
                              position: "absolute",
                              right: 45,
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                            }}
                          >
                            <SearchIcon
                              onClick={() =>
                                getAccountData(filterObj.accountName)
                              }
                            />
                          </InputAdornment>
                        </>
                      ),
                    }}
                  />
                )}
              />

              <Divider sx={{ my: 2 }} />
              <FormControl fullWidth>
                <FormLabel>Report Options</FormLabel>
                <RadioGroup
                  value={filterObj.reportOption}
                  onChange={(e) =>
                    handleFilterChange("reportOption", e.target.value)
                  }
                >
                  <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                    {" "}
                    <FormControlLabel
                      value="oDueSummary"
                      control={<Radio />}
                      label="O/s Due Summary"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filterObj.oDueSummaryDetail}
                          onChange={(e) =>
                            handleFilterChange(
                              "oDueSummaryDetail",
                              e.target.checked
                            )
                          }
                        />
                      }
                      label="Detail"
                    />
                  </Box>

                  <FormControlLabel
                    value="oDueDetail"
                    control={<Radio />}
                    label="O/s Due Detail"
                  />
                  <FormControlLabel
                    value="osDueSummaryPendingInvoice"
                    control={<Radio />}
                    label="O/S Due Summary (Pending Invoice)"
                  />
                  {filterObj.reportOption === "osDueSummaryPendingInvoice" && (
                    <Select
                      fullWidth
                      size="small"
                      value={filterObj.osDueSummaryPendingInvoiceVal}
                      onChange={(e) =>
                        handleFilterChange(
                          "osDueSummaryPendingInvoiceVal",
                          e.target.value
                        )
                      }
                    >
                      <MenuItem value="General">General</MenuItem>
                      <MenuItem value="Excel">Excel</MenuItem>
                      <MenuItem value="Summary">Summary</MenuItem>
                    </Select>
                  )}

                  <FormControlLabel
                    value="agingDetails"
                    control={<Radio />}
                    label="Ageing Details"
                  />
                  {filterObj.reportOption === "agingDetails" && (
                    <Box sx={{ ml: 3 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={filterObj.agingDetailsDueDate}
                            onChange={(e) =>
                              handleFilterChange(
                                "agingDetailsDueDate",
                                e.target.checked
                              )
                            }
                          />
                        }
                        label="Due Date"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={filterObj.agingDetailsExcelFormat}
                            onChange={(e) =>
                              handleFilterChange(
                                "agingDetailsExcelFormat",
                                e.target.checked
                              )
                            }
                          />
                        }
                        label="Excel Format"
                      />
                    </Box>
                  )}

                  <FormControlLabel
                    value="agingSummary"
                    control={<Radio />}
                    label="Aging Summary"
                  />
                  {filterObj.reportOption === "agingSummary" && (
                    <Select
                      fullWidth
                      size="small"
                      value={filterObj.agingSummaryVal}
                      onChange={(e) =>
                        handleFilterChange("agingSummaryVal", e.target.value)
                      }
                    >
                      <MenuItem value="With Drill Down">
                        With Drill Down
                      </MenuItem>
                      <MenuItem value="Without Drill Down">
                        Without Drill Down
                      </MenuItem>
                      <MenuItem value="Over Due Ageing">
                        Over Due Ageing
                      </MenuItem>
                      <MenuItem value="Over Due Forecast">
                        Over Due Forecast
                      </MenuItem>
                      <MenuItem value="Over Due Forecast Branchwise">
                        Over Due Forecast Branchwise
                      </MenuItem>
                      <MenuItem value="Daywise  Ageing">
                        Daywise Ageing
                      </MenuItem>
                    </Select>
                  )}

                  <FormControlLabel
                    value="agingDetailPendingInvoice"
                    control={<Radio />}
                    label="Ageing Detail (Pending Invoice)"
                  />

                  <FormControlLabel
                    value="trialBalance"
                    control={<Radio />}
                    label="Trial Balance"
                  />
                  {filterObj.reportOption === "trialBalance" && (
                    <Select
                      fullWidth
                      size="small"
                      value={filterObj.trialBalanceVal}
                      onChange={(e) =>
                        handleFilterChange("trialBalanceVal", e.target.value)
                      }
                    >
                      <MenuItem value="Consolidated">Consolidated</MenuItem>
                      <MenuItem value="Full">Full</MenuItem>
                      <MenuItem value="Partial">Partial</MenuItem>
                    </Select>
                  )}
                </RadioGroup>
              </FormControl>

              <Divider sx={{ my: 2 }} />
              <FormControl fullWidth>
                <Typography>Parent A/c</Typography>
                <Select
                  value={filterObj.parentAccount}
                  onChange={(e) =>
                    handleFilterChange("parentAccount", e.target.value)
                  }
                  sx={{
                    "& .MuiSelect-select": {
                      py: 0.5,
                    },
                  }}
                >
                  {dropdownData.parentAC.map((item) => (
                    <MenuItem key={item.UId} value={item.Name1}>
                      {item.Name1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Divider sx={{ my: 2 }} />
              {["group", "segment", "salesman", "class"].map((key) => (
                <FormControl fullWidth key={key}>
                  <Typography>
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </Typography>
                  <Select
                    value={filterObj[key]}
                    onChange={(e) => handleFilterChange(key, e.target.value)}
                    sx={{
                      "& .MuiSelect-select": {
                        py: 0.5,
                      },
                    }}
                  >
                    {dropdownData[key]?.map((opt) => (
                      <MenuItem key={opt.UId} value={opt.UId}>
                        {opt.Name1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ))}

              <Divider sx={{ my: 2 }} />
              <Button variant="contained" fullWidth onClick={handleViewReport}>
                View Report
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<RestartAltIcon />}
                fullWidth
                onClick={handleReset}
                sx={{ mt: 2 }}
              >
                Reset
              </Button>
            </Paper>
          </Grid>
        )}

        <Grid item xs={12} md={showFilters ? 9 : 12}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              height: isMdUp ? "calc(100vh - 122px)" : "auto",
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Payable Report
            </Typography>
            {/* <Box sx={{ flex: 1, overflow: "hidden" }}>
              {reportUrl ? (
                <div
                  style={{ width: "100%", height: "100vh", overflow: "hidden" }}
                >
                  <iframe
                    title="Finance Payable Report"
                    src={reportUrl}
                    width="100%"
                    height="100%"
                    style={{ border: "none", display: "block" }}
                  />
                </div>
              ) : (
                <Box
                  sx={{
                    border: "1px dashed grey",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.secondary",
                  }}
                >
                  Report preview area
                </Box>
              )}
            </Box> */}
            {reportUrl ? (
              <iframe
                src={reportUrl}
                title="Finance Payable Report"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  overflow: "hidden", // ✅ Final fix: no extra scroll from iframe
                  display: "block", // ✅ Prevents inline white space
                }}
              />
            ) : (
              <Box
                sx={{
                  border: "1px dashed grey",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "text.secondary",
                }}
              >
                Report preview area
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FinancePayableReport;
